import {
  Address,
  PolicyTypeCd,
  Vehicle,
} from '@aaa-ncnu-ie/mypolicy-api-policies';
import { Stack, Typography, useMediaQuery } from '@mui/material';

import CircleDivider from '../../../assets/icons/CircleDivider';
import colors from '../../../constants/colors';
import theme from '../../../styles/theme';
import {
  policyTypeMap,
  policyTypeMapSelector,
} from '../../../utils/policyTypeUtil';

interface AutoPayCardHeaderProps {
  policyTypeCd: PolicyTypeCd;
  policyNumber: string;
  vehicles?: Vehicle[];
  insuredAddress?: Address;
  isNanoPolicy?: boolean;
  fullProductCode: string;
}

const AutoPayCardHeader = ({
  policyTypeCd,
  policyNumber,
  vehicles,
  insuredAddress,
  isNanoPolicy,
  fullProductCode,
}: AutoPayCardHeaderProps) => {
  const isMobile = useMediaQuery(theme.breakpoints.down('tablet'));
  const policyIconIndex = policyTypeMapSelector(policyTypeCd, fullProductCode);
  const PolicyIcon = policyTypeMap[policyIconIndex].icon;

  return (
    <Stack direction="row" spacing={2} sx={{
      alignItems: "center"
    }}>
      {!isMobile && <PolicyIcon id={policyNumber} />}
      <Stack sx={{
        width: "100%"
      }}>
        <Stack
          direction="row"
          sx={{
            alignItems: "center",
            justifyContent: "space-between"
          }}>
          <Stack direction="row" sx={{
            alignItems: "center"
          }}>
            {isMobile && PolicyIcon && (
              <PolicyIcon
                id={policyNumber}
                sx={{ height: 32, width: 32, mr: 1 }}
              />
            )}
            <Typography
              sx={{
                fontWeight: 700,
                fontSize: { mobile: 16, tablet: 18 },
                color: colors.csaaBlack,
              }}
            >
              {policyNumber.toUpperCase()}
            </Typography>
          </Stack>
        </Stack>
        <Stack
          direction="row"
          divider={<CircleDivider sx={{ marginLeft: 1, marginRight: 1 }} />}
          sx={{
            alignItems: "center",
            flexWrap: "wrap"
          }}>
          {vehicles &&
            !isNanoPolicy &&
            vehicles?.map((vehicle, idx) => (
              <Typography
                key={idx}
                sx={{
                  fontFamily: 'Cabin',
                  fontKerning: 'normal',
                  fontSize: 14,
                  fontWeight: 400,
                  color: colors.csaaBlack,
                }}
              >
                {`${vehicle.year} ${vehicle.make} ${vehicle.series}`}
              </Typography>
            ))}
          {isNanoPolicy && (
            <Typography
              sx={{
                fontFamily: 'Cabin',
                fontKerning: 'normal',
                fontSize: 14,
                fontWeight: 400,
                color: colors.csaaBlack,
              }}
            >
              Named Non-owner
            </Typography>
          )}
          {insuredAddress && (
            <Typography
              className="csaa-qm-encrypt"
              sx={{
                fontFamily: 'Cabin',
                fontKerning: 'normal',
                fontSize: 14,
                fontWeight: 400,
                color: colors.csaaBlack,
              }}
            >
              {`${insuredAddress.addressLine1}, ${insuredAddress.city}, ${
                insuredAddress.stateProvCd
              } ${insuredAddress.postalCode.slice(0, 5)}`}
            </Typography>
          )}
        </Stack>
      </Stack>
    </Stack>
  );
};

export default AutoPayCardHeader;
